// filepath: /C:/Users/nitis/Desktop/uii/client/src/components/shared/Notification.js
import { useEffect } from 'react';
import styles from './notification.module.css';
const Notification = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000); // Close the notification after 10 seconds

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <div className={styles.notification}>
            {message}
        </div>
    );
};

export default Notification;